// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'
import Icons from 'ui/Icons'

type Props = {
  /** Button content */
  children: React.Node,
  onClick?: () => void,
  className?: string,
  ...React.ComponentProps<'button'>,
}

const StyledBreadcrumbButton = tw.button`
  mb-4
  flex
  space-x-1
  items-center
  text-sm
  text-zentake
  mt-6
  !outline-none
  hover:opacity-80
`

/** A button used in the breadcrumbs */
function BreadcrumbButton({ children, ...props }: Props): React.Node {
  return (
    <StyledBreadcrumbButton {...props}>
      <Icons.ChevronLeft color="text-zentake" />
      {children}
    </StyledBreadcrumbButton>
  )
}

export default BreadcrumbButton
